import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { fontSize } from "@root/shared/styles/sprinkles.css";
import { type ToggleButtonText } from "@root/clientFrontend/features/scout/components/WorkSelector/type";

type Props = {
  text: ToggleButtonText;
  onClick: () => void;
  className: string;
};

export const ToggleButton: FC<Props> = ({ text, onClick, className }) => (
  <button type="button" onClick={onClick} className={className}>
    <Icon name="sliders" fontSize={fontSize["fs-16"]} />
    {text}
  </button>
);
